import InternalNote from "./InternalNote";
import ManufacturerNote from "./ManufacturerNote";
import { UserOrder } from "../../../../interfaces";

const Notes = ({
  order,
  mutate,
}: {
  order: UserOrder;
  mutate: (state: UserOrder) => void;
}) => {
  /**
   * This method is for update order in local state
   * @param { UserOrder } updatedOrder updated order that need to be updated in local state
   */
  const handleUpdateNote = (updatedOrder: UserOrder) => {
    mutate({ ...order, ...updatedOrder });
  };
  return (
    <div className="gap-30 row address-details">
      <InternalNote
        order={order}
        onUpdateInternalNote={(updatedOrder) => handleUpdateNote(updatedOrder)}
      />
      <ManufacturerNote
        order={order}
        onUpdateManufacturerNote={(updatedOrder) =>
          handleUpdateNote(updatedOrder)
        }
      />
    </div>
  );
};

export default Notes;
